import { get } from './generic.api';

export const fetchClientClippings = async (params = {}) => {
  try {
    const response = await get('/clients/intranet/clippings/', params);
    return response;
  } catch (error) {
    console.error('Erro ao carregar clippings da intranet:', error.response || error);
    throw error;
  }
};

export const fetchClientClippingDetail = async (id) => {
  try {
    if (!id) throw new Error('ID do clipping é obrigatório');
    const response = await get(`/clients/intranet/clippings/${id}/`);
    return response;
  } catch (error) {
    console.error(`Erro ao carregar detalhe do clipping ${id}:`, error.response || error);
    throw error;
  }
};